import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {SignInUserDto} from './dto/SignInUserDto';
import {environment} from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {

  private baseUrl: string = environment.api.baseUrl;
  private socialLoginUri: string = environment.api.socialLogin;

  constructor(private http: HttpClient) {
  }

  signWithGoogle(email: string,
                 name: string,
                 photoUrl: string,
                 id: string,
                 idToken: string): Observable<SignInUserDto> {
    const url = `${this.baseUrl}${this.socialLoginUri}`;
    return this.http
      .post<any>(url, {
        email: email,
        name: name,
        imageUrl: photoUrl,
        providerId: id,
        providerIdToken: idToken,
        providerType: 'GOOGLE',
      });
  }
}
